import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { RoleService } from "src/app/_services/role.service";
import { GetAdministratorRoles, GetAdministratorRolesSuccess, GetAdministratorRolesError } from "./role.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { of } from "rxjs";
import { Role } from "src/app/_models/Role";

@Injectable()
export class RoleEffects {
  constructor (
    private actions$: Actions,
    private roleService: RoleService
  ) {}

  public getAdministrativeRolesEffects$ = createEffect(() => 
    this.actions$.pipe(
      ofType(GetAdministratorRoles),
      switchMap(() => 
        this.roleService.getAdministratorRoles$().pipe(
          map((responseResult: Role[]) => {
            return GetAdministratorRolesSuccess({ result: responseResult });
          }),
          catchError((error: any) => {
            return of(GetAdministratorRolesError({error: error}));
          })
        )
      )
    )
  );
}